module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  title: 'Online Car Finance | Your Perfect Car Loan Match | Driva', // Default Site Title used for SEO & PWA
  description:
    'Online car finance made easy with Driva. We find the best car loan option for you. We give you the options, you make the choice.', // Default Site Decription used for SEO
  siteName: 'Driva', // Sitename for Facebook
  siteLanguage: 'en', // Language Tag on <html> element
  banner: '/open-graph.jpg', // Default OpenGraph image
  ogLanguage: 'en_NZ', // Facebook Language

  // JSONLD / Manifest
  icon: 'src/images/driva-icon.png', // Used for manifest favicon, splash screen, and icon generation
  shortName: 'Driva', // shortname for manifest. MUST be shorter than 12 characters
  author: 'Driva', // Author for schemaORGJSONLD
  themeColor: '#97EDCC', // PWA Icon background & address bar colour if installed on desktop
  backgroundColor: '#F8F7F7', // PWA colour shown before styles and content loads, should match the background-color CSS property in the site’s stylesheet

  twitter: '', // Twitter Username
};
